import styled from 'styled-components';

export const MarketingImage_Root = styled.div`
    display: flex;
    a, img {
        width: 100%;
    }
`;
